import MenuPosition from "@/ui-components/MenuPosition";
import { Box } from "@mui/material";
import React from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

const notActiveIcon = {
  padding: "7px",
};

const activeIcon = {
  borderRadius: "8px",
  border: "1px solid var(--primary-mint-600)",
  background: "var(--primary-mint-400)",
  padding: "6px",
  color: "var(--dark-gray-800)",
};

interface MenuLinkProps {
  to: string;
  id: string;
  label: string;
  onMouseEnter?: () => void;
}

export const MenuLink: React.FC<React.PropsWithChildren<MenuLinkProps>> = ({
  id,
  to,
  label,
  children,
  onMouseEnter,
}) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to);
  return (
    <Link data-testid={id} to={to} onMouseEnter={onMouseEnter}>
      <MenuPosition text={label}>
        <Box sx={isActive ? activeIcon : notActiveIcon} data-testid={`menu-link-${isActive ? "active" : "inactive"}`}>
          {children}
        </Box>
      </MenuPosition>
    </Link>
  );
};
